//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
import * as ISchema from "@schema";

// goals-wrapper imports
import IGoalsWrapper from "./goals-wrapper.d";
import * as styles from "./goals-wrapper.styles";

// components
import { ProCalloutCardButton } from "@clockwise/web-commons/src/ui/pro-callout-card-button";

// other internals
import { MeetingReliefGoal } from "./";
import { fragments } from "./GoalsWrapper.gql";
import { H2 } from "@ui";
import ReduxState from "../../declarations/state.d";

// components
import { ProBadge } from "@clockwise/web-commons/src/ui/pro-badge";

// redux
import { setPricingDialogOpen } from "@actions/payments.actions";

// util
import { getFeatureGridFromOrg } from "@util/feature-grid.util";
import { track, TrackingEvents } from "@clockwise/web-commons/src/util/analytics.util";

//////////////////
// COMPONENT
//////////////////
export class GoalsWrapperComponent extends React.Component<IGoalsWrapper.GoalsWrapperProps, {}> {
  constructor(props: IGoalsWrapper.GoalsWrapperProps) {
    super(props);
  }

  public render() {
    // only show smart hold ui if they have smart holds enabled
    // const smartHoldGoals = this.props.org.userGoals.edges.map(edge => edge.node);
    // const hasHold = smartHoldGoals && smartHoldGoals.find(goal => !goal.isDeleted && goal.goalId === standardGoals.EmailTriage) || null;

    const featureGrid = getFeatureGridFromOrg(this.props.org);
    const meetingReliefSettingVisibility =
      featureGrid?.featureStates.meetingReliefSettingVisibility;

    if (meetingReliefSettingVisibility === ISchema.MeetingReliefSettingVisibility.HideSetting) {
      return null;
    }

    const featureDisabledByPaywall =
      meetingReliefSettingVisibility === ISchema.MeetingReliefSettingVisibility.DisabledByPaywall;

    return (
      <div style={styles.container}>
        <div style={styles.wrapperGroup}>
          <div style={{ display: "flex", alignItems: "center" }}>
            {!this.props.isWebSettings && (
              <H2>
                Should Clockwise try to spread out consecutive meetings?
                {meetingReliefSettingVisibility !==
                  ISchema.MeetingReliefSettingVisibility.ShowWithoutBadge && (
                  <span style={{ marginLeft: 10 }}>
                    <ProBadge />
                  </span>
                )}
              </H2>
            )}
          </div>
          {featureDisabledByPaywall && (
            <ProCalloutCardButton
              onViewPlans={() => {
                this.props.setPricingDialogOpen(true);
                track(TrackingEvents.PAYWALLS.SETTINGS_MEETING_RELIEF_CALLOUT_CLICK_VIEW_PLANS);
              }}
            />
          )}
          <div>
            <MeetingReliefGoal {...this.props} disabled={featureDisabledByPaywall} />
          </div>
        </div>
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: ReduxState.Redux, _ownProps: IGoalsWrapper.Container) {
  return {};
}

const reduxContainer = connect(mapStateToProps, {
  setPricingDialogOpen,
})(GoalsWrapperComponent);

//////////////////
// RELAY
//////////////////
export const GoalsWrapper = createFragmentContainer(reduxContainer, fragments);
